import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentTime: 0,
  timeToJump: 0,
  toPlay: false,
  isPlaying: false,
  isMinimized: false,
  isMute: false,
  playbackSpeed: 1,
  progress: 0,
  duration: 0,
  isPIPMode: false,
  isVideoModalOpen: false,
  transcriptTab: 'Transcript',
};

export const { reducer, actions } = createSlice({
  name: 'interviewVideo',
  initialState,
  reducers: {
    updateCurrentTime: (state, action) => {
      state.currentTime = action.payload;
    },
    updateTimeToJump: (state, action) => {
      state.timeToJump = action.payload;
    },
    setToPlay: (state, action) => {
      state.toPlay = action.payload;
    },
    setIsPlaying: (state, action) => {
      state.isPlaying = action.payload;
    },
    setIsMinimized: (state, action) => {
      state.isMinimized = action.payload;
    },
    setIsMute: (state, action) => {
      state.isMute = action.payload;
    },
    setPlaybackSpeed: (state, action) => {
      state.playbackSpeed = action.payload;
    },
    setProgress: (state, action) => {
      state.progress = action.payload;
    },
    setDuration: (state, action) => {
      state.duration = action.payload;
    },
    setPIPMode: (state, action) => {
      state.isPIPMode = action.payload;
    },
    setVideoModalOpen: (state, action) => {
      state.isVideoModalOpen = action.payload;
    },
    resetVideoState: () => {
      return initialState;
    },
    setTranscriptTab: (state, action) => {
      state.transcriptTab = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  updateCurrentTime,
  updateTimeToJump,
  setToPlay,
  setIsPlaying,
  setIsMinimized,
  setIsMute,
  setPlaybackSpeed,
  setProgress,
  setDuration,
  setPIPMode,
  setVideoModalOpen,
  resetVideoState,
  setTranscriptTab,
} = actions;
export default reducer;
